import { render, staticRenderFns } from "./edit-sms.vue?vue&type=template&id=51b3e92c&scoped=true"
import script from "./edit-sms.vue?vue&type=script&lang=js"
export * from "./edit-sms.vue?vue&type=script&lang=js"
import style0 from "./edit-sms.vue?vue&type=style&index=0&id=51b3e92c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b3e92c",
  null
  
)

export default component.exports